import CompletenessIndicator from "@/components/CompletenessIndicator/CompletenessIndicator";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import YearSelector from "@/components/YearSelector/YearSelector";
import useTrackOnLoad from "@/hooks/useTrackPageview";
import { useDashboardYear } from "@/pages/dashboard/hooks/useDateRange";
import { useGetTravelModeOverview } from "@/pages/employee/travel_modes/useTravelMode";
import { useGetPackagingMaterials } from "@/pages/packaging_materials/usePackagingMaterials";
import { ApiOutlined } from "@ant-design/icons";
import { useGetConsumables } from "../consumables/useConsumables";
import { useGetGoodsAndServicesItems } from "../goods_and_services/useGoodsAndServices";
import { useGetMaterials } from "../materials/useMaterials";
import "./Overview.scss";
import Section from "./Section/Section";

export default function MatchingOverview() {
  useTrackOnLoad("Overview Viewed");
  const { year } = useDashboardYear();

  const materialsQuery = useGetMaterials({ year, enabled: !!year });
  const packagingMaterialsQuery = useGetPackagingMaterials({ year, enabled: !!year });
  const consumablesQuery = useGetConsumables({ year, enabled: !!year });
  const travelModesQuery = useGetTravelModeOverview({ year, enabled: !!year });
  const goodsAndServicesQuery = useGetGoodsAndServicesItems({ year, enabled: !!year });

  return (
    <div className="Home">
      <PageHeader title={"Overview"} />
      <div className="pickers">
        <YearSelector />
        <CompletenessIndicator type={"matching"} />
      </div>
      <div className="sections">
        <Section
          name={"Matching"}
          description={"Match all incomplete value to an impact reference."}
          icon={
            <ApiOutlined
              width={18}
              height={14}
            />
          }
          stats={[
            {
              name: "Materials",
              description: "Materials per product.",
              query: materialsQuery,
              to: "/matching/materials",
            },
            {
              name: "Packaging materials",
              description: "Product and logistics packaging materials.",
              query: packagingMaterialsQuery,
              to: "/matching/packaging/materials",
            },
            {
              name: "Goods and services",
              description: "Goods and services used in facilities.",
              query: goodsAndServicesQuery,
              to: "/goods_and_services",
            },
            {
              name: "Consumables",
              description:
                "Consumables such as packaging that can be used in products or facilities.",
              query: consumablesQuery,
              to: "/consumables",
            },
            {
              name: "Travel modes",
              description: "Manage travel modes and their impacts.",
              query: travelModesQuery,
              to: "/employees/travel_modes",
            },
          ]}
        />
      </div>
    </div>
  );
}
